var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { getClientData, useModal } from '@lucidlink/uicore';
import { useLocalStorage } from '@lucidlink/workspacemanagement';
import { hasUnreliableDownloads } from '../../file-contexts-common';
import { UnreliableDownloadModal } from '../components';
import { UNRELIABLE_DOWNLOAD_MODAL_DISMISSED_STORAGE_KEY, UNRELIABLE_DOWNLOAD_MODAL_ID, } from '../constants';
export const useConfirmUnreliableDownload = () => {
    _react_refresh_temp_1();
    const { closeModal, openModal } = useModal({
        closeOnUnmount: true,
        modalId: UNRELIABLE_DOWNLOAD_MODAL_ID,
    });
    const shouldConfirmDownload = useMemo(() => hasUnreliableDownloads(getClientData()), []);
    const { setValue: setIsUnreliableDownloadModalDismissed, value: isUnreliableDownloadModalDismissed, } = useLocalStorage(UNRELIABLE_DOWNLOAD_MODAL_DISMISSED_STORAGE_KEY);
    const isUnreliableDownloadModalDismissedRef = useRef(isUnreliableDownloadModalDismissed);
    useEffect(() => {
        isUnreliableDownloadModalDismissedRef.current =
            isUnreliableDownloadModalDismissed;
    }, [isUnreliableDownloadModalDismissed]);
    const confirmUnreliableDownload = useCallback(() => {
        if (isUnreliableDownloadModalDismissedRef.current) {
            return Promise.resolve(true);
        }
        const { promise, resolve } = Promise.withResolvers();
        const settle = (isConfirmed) => {
            closeModal();
            resolve(isConfirmed);
        };
        openModal({
            content: (_jsx(UnreliableDownloadModal, { onCancel: () => settle(false), onProceed: (shouldNotShowAgain) => {
                    if (shouldNotShowAgain) {
                        setIsUnreliableDownloadModalDismissed(true);
                    }
                    settle(true);
                } })),
        });
        return promise;
    }, [closeModal, openModal, setIsUnreliableDownloadModalDismissed]);
    return { confirmUnreliableDownload, shouldConfirmDownload };
};
_react_refresh_temp_1(useConfirmUnreliableDownload, "TD2JMTaODua7I+cESQfeUM/8tgk=", false, () => [useModal, useLocalStorage]);
